const ACTION_SCOPE = '[DOE toetsen]';

export class LoadToetsen {
  static readonly type = `${ACTION_SCOPE} Load toetsen`;
}
